(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var phone = window.matchMedia('(max-width: 749px)');

    function setup(root) {
      var button = root.querySelector('[data-fk-reviews-more]');
      if (!button || root.dataset.fkReady === 'true') return;
      root.dataset.fkReady = 'true';
      var initial = parseInt(root.dataset.fkInitial || '5', 10);
      var ticking = false;

      function apply() {
        ticking = false;
        var container = root.querySelector('.areviews_load_more_container');
        var items = container ? container.querySelectorAll(':scope > .item') : [];
        var appMore = root.querySelector('.areviews_load_more_wrapper');
        var folded = phone.matches && !root.classList.contains('fk-reviews--expanded') && items.length > initial;
        if (folded) {
          var first = items[initial];
          var top = first.offsetTop;
          // Masonry sets each card's top in an inline style; fall back to flow layout.
          if (first.style.top) top = parseFloat(first.style.top) || top;
          container.style.maxHeight = Math.max(0, top - 12) + 'px';
          container.style.overflow = 'hidden';
        } else if (container) {
          container.style.maxHeight = '';
          container.style.overflow = '';
        }
        if (appMore) appMore.style.display = folded ? 'none' : '';
        button.hidden = !folded;
      }

      function schedule() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(apply);
      }

      button.addEventListener('click', function () {
        root.classList.add('fk-reviews--expanded');
        apply();
        window.dispatchEvent(new Event('resize'));
      });

      // The app renders after its script loads and re-lays out as images
      // arrive; follow every change until the cards settle.
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(root);
      phone.addEventListener('change', schedule);
      window.addEventListener('load', schedule);
      schedule();
    }

    function init() {
      document.querySelectorAll('[data-fk-reviews]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
